<form *ngIf="loaded" [formGroup]="formGroup">
  <div class="card-inline">
    <div class="margin-right-xs margin-top-xx medium-width">
      <referring-physician-autocomplete
        formControlName="ReferringPhysician"
      ></referring-physician-autocomplete>
    </div>
    <div class="margin-right-xs margin-top-xx medium-width">
      <app-referring-physician-institute
        formControlName="ReferringPhysicianInstitute"
      ></app-referring-physician-institute>
    </div>

    <mat-form-field class="card-inline margin-right-small">
      <input
        matInput
        formControlName="OrderDate"
        #dateOrder
        [matDatepicker]="picker"
        placeholder="Fecha {{ validityDays }}"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      *ngIf="requiredCredentian"
      class="card-inline margin-right-small"
    >
      <mat-label>Número de afiliado</mat-label>
      <input
        [mask]="mask"
        formControlName="MemberNumber"
        [showMaskTyped]="showMaskTyped"
        [dropSpecialCharacters]="false"
        type="text"
        matInput
      />
    </mat-form-field>

    <mat-form-field
      *ngIf="requiredPreAuth"
      class="card-inline margin-right-small"
    >
      <mat-label>Número de pre autorización</mat-label>
      <input formControlName="PreAuthorizationNumber" type="text" matInput />
    </mat-form-field>

    <div>
      <mat-form-field
        *ngIf="requiredDiagnosis"
        class="medium-width margin-right-small"
      >
        <input
          type="text"
          matInput
          placeholder="Diagnóstico C.I.E."
          formControlName="Diagnostic"
          [matAutocomplete]="autDiagnosisCIE"
          required
        />
        <mat-autocomplete
          #autDiagnosisCIE="matAutocomplete"
          [displayWith]="filterCompleteautDiagnosisCIE.displayFn"
        >
          <mat-option
            *ngFor="let diagnosisCIE of filteredDiagnosesCIEOptions | async"
            [value]="diagnosisCIE"
          >
            {{ diagnosisCIE.Name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="margin-right-xs margin-top-xx">
        <input
          matInput
          placeholder="Observaciones"
          formControlName="Observations"
        />
      </mat-form-field>
    </div>
  </div>
</form>
